import axios from 'axios'
import {Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/request/token'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60000
})

//request拦截器
service.interceptors.request.use(config => {

  if(null == config.needToken || undefined == config.needToken ||  config.needToken) {
    if (getToken()) {
      config.headers['Oauth-Token'] = getToken()
    } 
  }

  return config
}, error => {
  Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(

  response => {
    //全局统一处理 Session超时
    if (response.headers['session_time_out'] == 'timeout') {
      // store.dispatch('fedLogOut');
    }

    const res = response.data;
    //0 为成功状态
    if (res.code !== 0) {
      // 后台异常反馈的信息
      // if (res.code === 1) {
      //   Message({
      //     type: 'error',
      //     showClose: true,
      //     message: res.msg
      //   })
      // }

      //90001 Session超时
      if (res.code === 90001) {
        return Promise.reject('error');
      }

      //401 用户未登录
      if (res.code === 401) {
        // Message({
        //   type: 'warning',
        //   showClose: true,
        //   message: '未登录或登录超时，请登录'
        // })

        // 清空前端登录信息
        store.dispatch('fedLogOut')

        // store.dispatch('/login')
        // this.$router.push('/');
        // this.$router.push({path: `/login`});
        // next({path: '/login'});
        location.href = '/#/login'
        return Promise.reject('error');
      }

      //70001 权限认证错误
      if (res.code === 70001) {
        Message({
          type: 'warning',
          showClose: true,
          message: '你没有权限访问哦'
        })
        return Promise.reject('error');
      }

      // return Promise.reject(res.msg);
      return response.data;
    } else {
      return response.data;
    }
  },
  error => {
    Message({
      type: 'warning',
      showClose: true,
      message: '连接超时'
    })
    return Promise.reject('error')
  })

export default service



// WEBPACK FOOTER //
// ./src/request/index.js